// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__182yx","description":"PatientConsentPreview_description__92Lyn"};